module.exports = __webpack_public_path__ + "img/1dc8446.svg";